import React, { useCallback} from 'react';
import { Form } from 'semantic-ui-react';
import './Container.css';
import { AddBtn } from '../AddBtn';
import List from '../List';
import ContainerList from './ContainerList';
import { useDispatch, useSelector } from 'react-redux';
import { useDocument } from '../../GB_App/hooks/useDocument';
import {CustomLoader} from '../../commonComponents/formComponents/loader'
function ContainerTab(props) {
  const { isImportShipment, errorInfo={},fieldPattern, validateError,initContainersTabValidationCDS } = props
  const { isLoading,AddItem, deleteItem, updateItem, saveItem } = useDocument({ actionType: "CONTAINER_TAB", tableName: "containerList", containerKey: "container" })
  const isFormEnabled = false;
  const containerList = useSelector((state) => state.containerReducer.containerList) || [];

  const dispatch = useDispatch()

  const resetContainerErrors = useCallback(() => {  dispatch(initContainersTabValidationCDS()) },[AddItem, deleteItem])
  
  const renderItem = useCallback((item, idx) => {
    return <ContainerList
      key={item.id}
      idx={idx}
      errorInfo={errorInfo}
      fieldPattern={fieldPattern}
      validateError={validateError}
      resetContainerErrors={resetContainerErrors}
      isImportShipment={isImportShipment}
      item={item}
      updateData={updateItem}
      deleteData={deleteItem}
      saveData={saveItem}
      isFormEnabled={isFormEnabled}
    />
  }, [isFormEnabled, updateItem, deleteItem, saveItem, AddItem,isImportShipment,errorInfo,fieldPattern,validateError,resetContainerErrors])
  
  return (
    <div className={`formContentareaC88`} style={{ height: 'calc(100vh - 329px)' }}>
      <Form.Group className="float-container scrollY">
        <List renderItem={renderItem}
          dataSource={containerList}
        />
      
      { isLoading && <CustomLoader /> }

     {
      containerList?.length<9 && 
      <AddBtn 
        id="addContainer" 
        disabled={(isFormEnabled || isLoading)} 
        onClick={()=>AddItem(null,false,resetContainerErrors)}
        text="Add" ></AddBtn>
     }

      </Form.Group>
    </div>
  );
}
export default ContainerTab;
